export const BYTES_IN_2MB = 2 * 1024 * 1024;
